// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5be21c4d","453":"8f616d50"}[chunkId] + ".chunk.js";
};